import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import AddressBookList from './AddressBookList';
import AddEditReferralProviderPopup from '../Patient/Referral/AddEditReferralProviderPopup';
import AddEditReferralFacilityPopup from '../Patient/Referral/AddEditReferralFacilityPopup';
import AddEditReferralInsurancePopup from '../Patient/Referral/AddEditReferralInsurancePopup';

function AddressBookPopup({
  onClose,
  type = 2,
  selectAny = false,
  onSelectAddress,
}) {
  const [addBookData, setAddBookData] = useState([]);
  const [typeState, setTypeState] = useState(type);
  const [srchVal, setSrchVal] = useState('');

  const [reload, setReload] = useState(false);
  const onReload = () => setReload(!reload);
  const [editPopup, setEditPopup] = useState({
    open: false,
    referringMasterId: '',
  });

  useEffect(() => {
    const loadAddressBook = async () => {
      // Logic to load address book data
      const response = await post('api/CommonTask/openAddresspopup', {
        searchStr: '',
        type: typeState,
        selectAny,
      });

      if (response.status === 200) {
        setAddBookData(response.data || []);
      }
    };
    loadAddressBook();
  }, [typeState, selectAny, reload]);

  const handleAddressSelect = (address) => {
    onSelectAddress(address, typeState);
  };

  const srch = srchVal?.toLowerCase() || '';

  let masterData = [];

  if (typeState === 2) {
    masterData = addBookData?.referringMaster || [];
  } else if (typeState === 3 || typeState === 5) {
    masterData = addBookData?.facilityMaster || [];
  } else if (typeState === 4) {
    masterData = addBookData?.insuranceMaster || [];
  }

  const addressBookDataList = masterData.filter((item) => {
    return (
      String(item?.nameLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.addressLabel || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.email || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.fax || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_l || '')
        .toLowerCase()
        .includes(srch) ||
      String(item?.phone_m || '')
        .toLowerCase()
        .includes(srch)
    );
  });

  return (
    <div>
      <div className="modalBackground">
        <div className="openAddressBook">
          <div className="addressBookHeader">
            <span className="addressTitle">
              <h2>Recipients Address Book</h2>
            </span>
            <span className="addressClose" onClick={onClose}>
              X
            </span>
          </div>
          <div className="addressBody">
            <div className="addressBodyRow">
              <input
                className="addressBookSearh"
                type="text"
                id="addressBookSearh"
                name="addressBookSearh"
                placeholder="Search recipents..."
                clickbutton="address-book-search"
                onChange={(e) => setSrchVal(e.target.value)}
              />
              <span
                className="button new-button cursor-style-for-link hide"
                id="address-book-search"
              >
                &nbsp;
              </span>
              <span
                className="address-book-search-delete hide"
                id="address-book-search-delete"
                onClick={null}
                clickbutton="address-book-search"
              >
                X
              </span>
            </div>
            <div className="addressBodyRow">
              {(() => {
                if (typeState === 2) {
                  return (
                    <AddressBookList
                      // addressBookData={addBookData?.referringMaster || []}
                      addressBookData={addressBookDataList}
                      type={typeState}
                      selectAny={selectAny}
                      handleAddressSelect={handleAddressSelect}
                      editPopup={editPopup}
                      setEditPopup={setEditPopup}
                    />
                  );
                } else if (typeState === 3 || typeState === 5) {
                  return (
                    <AddressBookList
                      // addressBookData={addBookData?.facilityMaster || []}
                      addressBookData={addressBookDataList}
                      type={typeState}
                      selectAny={selectAny}
                      handleAddressSelect={handleAddressSelect}
                      editPopup={editPopup}
                      setEditPopup={setEditPopup}
                    />
                  );
                } else if (typeState === 4) {
                  return (
                    <AddressBookList
                      // addressBookData={addBookData?.insuranceMaster || []}
                      addressBookData={addressBookDataList}
                      type={typeState}
                      selectAny={selectAny}
                      editPopup={editPopup}
                      handleAddressSelect={handleAddressSelect}
                      setEditPopup={setEditPopup}
                    />
                  );
                }
              })()}
              {/* <div id="addressbookListBlock" className="addressBodyLeft">
              <div
                className="bodyLeftAdd"
                onClick="openReferringProviderPopup();"
              >
                <h3 className="cursor">+ Add New Provider</h3>
              </div>
              <div className="bodyLeftContainer">
                <div className="bodyLeftRow">
                  <div
                    className="bodyLeftRowData cursor"
                    onClick="getMasterId('.$masterId.');"
                  >
                    <span className="left width100 name">Aijaz Ahmad</span>
                    <span className="left width100 Address">
                      Address city state zip
                    </span>
                    <span className="left width100 email">
                      &#9993;&nbsp;&nbsp;
                    </span>
                    <span className="left width100 email">
                      email@example.com
                    </span>
                    <span className="left width100 conctact">
                      91 9971228250
                    </span>
                  </div>
                  <div
                    className="bodyLeftRowAction"
                    onClick="editRefMasterPopup('<?php echo $val['id'];?>')"
                  >
                    &#9998;
                  </div>
                </div>
              </div>
            </div> */}
              <div className="addressBodyRight">
                <div
                  className={`bodyLeftAdd ${
                    typeState === 2 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(2)}
                >
                  Referring Provider/Clinics
                </div>
                <div
                  className={`bodyLeftAdd ${
                    typeState === 3 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(3)}
                >
                  Facilities
                </div>
                <div
                  className={`bodyLeftAdd ${
                    typeState === 4 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(4)}
                >
                  Insurance
                </div>
                <div
                  className={`bodyLeftAdd ${
                    typeState === 5 ? 'addressBookSelected' : ''
                  }`}
                  onClick={() => setTypeState(5)}
                >
                  Others
                </div>

                {/* <div className="bodyLeftAdd">Patients</div>
			<div className="bodyLeftAdd">Insurance</div>
			<div className="bodyLeftAdd">Others</div> */}
              </div>
            </div>
            <div className="button-submit right" onClick={onClose}>
              Close
            </div>
          </div>
        </div>
      </div>
      {typeState === 2 && editPopup.open && (
        <AddEditReferralProviderPopup
          onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
          typeState={typeState}
          onReload={onReload}
          editPopup={editPopup}
          setEditPopup={setEditPopup}
        />
      )}
      {(typeState === 3 || typeState === 5) && editPopup.open && (
        <AddEditReferralFacilityPopup
          onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
          typeState={typeState}
          onReload={onReload}
          editPopup={editPopup}
          setEditPopup={setEditPopup}
        />
      )}
      {typeState === 4 && editPopup.open && (
        <AddEditReferralInsurancePopup
          onClose={() => setEditPopup({ open: false, referringMasterId: '' })}
          typeState={typeState}
          onReload={onReload}
          editPopup={editPopup}
          setEditPopup={setEditPopup}
        />
      )}
    </div>
  );
}

export default AddressBookPopup;
